import { baseReducer } from '../../store/core/base-reducer';
import { emptyObject } from 'ui-components/default-props/empty';
import * as Actions from './scan-to-print.actions';
import * as PrintActions from './s2p-purchase-and-print.actions';
import * as VerifyActions from '../../scan/verify/store/scan-to-verify.actions';
import { DEFAULT_ORDERS_PAGE_URL } from '../../services/user-permission-service';

const initialState = {
  originatingUrl: DEFAULT_ORDERS_PAGE_URL,
  searchValue: '',
  orderNumberSearch: emptyObject,
  errors: [],
  statusIndicator: {
    status: 'zero',
    errors: [],
  },
  mode: '',
  isHeaderFocused: true,
  queue: {
    fulfillmentPlanIds: [],
    currentIndex: 0,
    batchName: '',
    isActive: false,
  },
};

const actionHandlerMap = {
  [Actions.SET_SCAN_SEARCH_VALUE]: (state, { searchValue }) => {
    return {
      ...state,
      searchValue,
    };
  },
  [Actions.SET_SCAN_TO_PRINT_PRINTER]: (state, { printerId, workstationId }) => {
    return {
      ...state,
      printerId,
      workstationId,
    };
  },
  [Actions.SET_SCAN_TO_PRINT_SCALE]: (state, { scaleId }) => {
    return {
      ...state,
      scaleId,
    };
  },
  [Actions.SEARCH_FOR_ORDER_NUMBER]: (state, { searchValue }) => {
    return {
      ...state,
      orderNumberSearch: {
        searchValue,
        isSearching: true,
      },
    };
  },
  [Actions.SEARCH_ORDER_NUMBER_SUCCESS]: (state, { orders }) => {
    const { orderNumberSearch } = state;
    return {
      ...state,
      errors: [],
      orderNumberSearch: {
        ...orderNumberSearch,
        isSearching: false,
        orders,
      },
    };
  },
  [Actions.SET_SCAN_TO_PRINT_ERRORS]: (state, { errors }) => {
    const { orderNumberSearch } = state;
    return {
      ...state,
      errors,
      orderNumberSearch: {
        ...orderNumberSearch,
        isSearching: false,
        orders: undefined,
      },
    };
  },
  [Actions.SELECT_FULFILLMENT_PLAN]: (state, { fulfillmentPlanId }) => {
    return {
      ...state,
      fulfillmentPlanId,
      isHeaderFocused: false,
    };
  },
  [Actions.CLEAR_ORDER_NUMBER_SEARCH]: (state, { error }) => {
    return {
      ...state,
      orderNumberSearch: initialState.orderNumberSearch,
      searchValue: '',
      error,
    };
  },
  [Actions.SAVE_PIPELINE_JOB_ID]: (state, { jobId }) => {
    return {
      ...state,
      jobId,
    };
  },
  [Actions.SCAN_TO_PRINT_LOAD_SHIPMENT_DETAILS]: (state, { fulfillmentPlanId }) => {
    return {
      ...state,
      errors: [],
      fulfillmentPlanId,
    };
  },
  [Actions.RESET_SCAN_TO_PRINT_MODE]: (state) => {
    return {
      ...state,
      statusIndicator: {
        status: 'zero',
        errors: [],
      },
      jobId: undefined,
      fulfillmentPlanId: undefined,
    };
  },
  [PrintActions.PRINT_SCAN_TO_PRINT_LABEL]: (state) => {
    return {
      ...state,
      statusIndicator: {
        status: 'printing',
        errors: [],
      },
    };
  },
  [PrintActions.START_PURCHASE_AND_PRINT_JOB]: (state) => {
    return {
      ...state,
      statusIndicator: {
        status: 'processing',
        errors: [],
      },
    };
  },
  [PrintActions.LABEL_SUCCESSFULLY_CREATED_FOR_SCAN_TO_PRINT]: (state) => {
    return {
      ...state,
      statusIndicator: {
        status: 'printing',
        errors: [],
      },
    };
  },
  [PrintActions.GENERIC_ERROR_HANDLING_FOR_SCAN_TO_PRINT]: (state) => {
    return {
      ...state,
      statusIndicator: {
        status: 'zero',
        errors: [],
      },
    };
  },
  [Actions.UPDATE_SCAN_TO_PRINT_MODE]: (state, { mode }) => {
    return {
      ...state,
      mode,
    };
  },
  [Actions.CLEAR_SCAN_TO_ERRORS]: (state) => {
    return {
      ...state,
      errors: [],
    };
  },
  [Actions.SET_SCAN_HEADER_FOCUS]: (state, { inactive }) => {
    return {
      ...state,
      isHeaderFocused: !inactive,
    };
  },
  [VerifyActions.SET_VERIFICATION_STATUS_FAILURE]: (state, { errors }) => {
    return {
      ...state,
      errors,
    };
  },
  [Actions.INITIALIZE_SCAN_QUEUE]: (state, { fulfillmentPlanIds, batchName }) => {
    return {
      ...state,
      queue: {
        fulfillmentPlanIds,
        currentIndex: 0,
        batchName,
        isActive: true,
      },
      fulfillmentPlanId: fulfillmentPlanIds[0],
      isHeaderFocused: false,
    };
  },
  [Actions.ADVANCE_QUEUE]: (state) => {
    const { queue } = state;

    if (!queue.fulfillmentPlanIds) {
      return state;
    }

    const nextIndex = queue.currentIndex + 1;
    const nextFulfillmentPlanId = queue.fulfillmentPlanIds[nextIndex];

    return {
      ...state,
      queue: {
        ...queue,
        currentIndex: nextIndex,
      },
      fulfillmentPlanId: nextFulfillmentPlanId,
      statusIndicator: {
        status: 'zero',
        errors: [],
      },
    };
  },
  [Actions.CLEAR_SCAN_QUEUE]: (state) => {
    return {
      ...state,
      queue: {
        fulfillmentPlanIds: [],
        currentIndex: 0,
        batchName: '',
        isActive: false,
      },
    };
  },
  [Actions.SET_QUEUE_POSITION]: (state, { currentIndex }) => {
    const { queue } = state;

    if (queue?.currentIndex === null || queue?.currentIndex === undefined || currentIndex > queue?.fulfillmentPlanIds?.length) {
      return state;
    }

    return {
      ...state,
      queue: {
        ...queue,
        currentIndex,
      },
    };
  },
};

export const ConnectedActionHandlerMap = baseReducer(initialState, actionHandlerMap);

export { namespace } from './scan-to-print.reducer.metadata';
